// extracted by mini-css-extract-plugin
module.exports = {"modal":"SubgroupCreate_modal__2XxZF"};